import { FunctionComponent } from 'react'
import { useLocation } from 'react-router-dom'
import ChangePassword from './changePassword'
import RequestNewPassword from './requestNewPassword'
import { useAuth } from '@/modules/context/AuthContext'

const ForgottenPassword: FunctionComponent = () => {
    const { user, logout } = useAuth()

    const params: URLSearchParams = new URLSearchParams(useLocation().search)

    if (user) logout()

    return params.get('token') === null ? <RequestNewPassword /> : <ChangePassword token={params.get('token')} />
}

export default ForgottenPassword
